(() => {
  if (customElements.get('product-bundle-offer')) return;

  class ProductBundleOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.abortController = new AbortController();

      this.config = this.parseJson('[data-bundle-config]');
      this.variants = this.parseJson('[data-bundle-variants]', []);

      if (!this.config || !this.variants.length) return;

      this.form = document.getElementById(this.config.productFormId);
      this.section =
        this.closest('.shopify-section') ||
        this.closest('section');

      this.drawer = document.getElementById(this.dataset.drawerId);
      this.confirmButton =
        this.drawer?.querySelector('[data-confirm-bundle-colors]');

      this.cards = Array.from(
        this.querySelectorAll('[data-bundle-card]')
      );

      this.colorButtons = Array.from(
        this.drawer?.querySelectorAll('[data-bundle-color]') || []
      );

      this.pieceElements = Array.from(
        this.drawer?.querySelectorAll('[data-bundle-piece]') || []
      );

     this.colors = this.getColorValues();

this.maxTier =
  Number(this.config.maxTier) === 2
    ? 2
    : 3;

this.selectedTier = this.parseTier(
  this.config.defaultBundle,
  2
);

      this.currentSize =
        this.getSelectedSize() ||
        this.getFirstAvailableSize();

      this.pendingSelections = {};
      this.confirmedSelections = {};

for (let tier = 1; tier <= this.maxTier; tier += 1) {
        this.pendingSelections[tier] =
          this.getDefaultSelections(tier);
        this.confirmedSelections[tier] = null;
      }

      this.hideNativeColorOption();
      this.bindEvents();
      this.syncSizeOptionAvailability();
      this.updateInterface();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    bindEvents() {
      const signal = this.abortController.signal;

      this.cards.forEach((card) => {
        const radio = card.querySelector('[data-bundle-radio]');
        const openButton = card.querySelector(
          '[data-open-bundle-drawer]'
        );

        radio?.addEventListener(
          'change',
          () => {
            if (radio.checked) {
              this.selectTier(card.dataset.bundleTier);
            }
          },
          { signal }
        );

        card.addEventListener(
          'click',
          (event) => {
            if (
              event.target.closest(
                'button, input, label, a'
              )
            ) {
              return;
            }

            this.selectTier(card.dataset.bundleTier);
          },
          { signal }
        );

        openButton?.addEventListener(
          'click',
          () => {
            this.selectTier(card.dataset.bundleTier);
            this.prepareDrawer();
          },
          { signal }
        );

        card
          .querySelectorAll('[data-open-bundle-drawer]')
          .forEach((button) => {
            if (button === openButton) return;

            button.addEventListener(
              'click',
              () => {
                this.selectTier(card.dataset.bundleTier);
                this.prepareDrawer();
              },
              { signal }
            );
          });
      });

      this.colorButtons.forEach((button) => {
        button.addEventListener(
          'click',
          () => this.selectDrawerColor(button),
          { signal }
        );
      });

      this.confirmButton?.addEventListener(
        'click',
        () => this.confirmColors(),
        { signal }
      );

      this.form?.addEventListener(
        'variant:change',
        (event) => this.handleVariantChange(event),
        { signal }
      );

      this.form?.addEventListener(
        'submit',
        (event) => this.handleFormSubmit(event),
        {
          capture: true,
          signal
        }
      );

      document.addEventListener(
        'productInfo:loaded',
        () => {
          this.syncSizeOptionAvailability();
          this.syncSubmitButtons();
        },
        { signal }
      );
    }

    hideNativeColorOption() {
      const optionNumber =
        Number(this.config.colorOptionIndex) + 1;

      const colorGroup = this.section?.querySelector(
        `[data-option-index="option${optionNumber}"]`
      );

      if (!colorGroup) return;

      colorGroup.hidden = true;
      colorGroup.setAttribute('aria-hidden', 'true');
      colorGroup.setAttribute(
        'data-bundle-hidden-option',
        ''
      );
    }

    selectTier(value) {
      const tier = this.parseTier(value, 1);

      this.selectedTier = tier;
      this.clearError();

      const radio = this.querySelector(
        `[data-bundle-radio][value="${tier}"]`
      );

      if (radio) radio.checked = true;

      if (!this.pendingSelections[tier]?.length) {
        this.pendingSelections[tier] =
          this.getDefaultSelections(tier);
      }

      this.updateInterface();
    }

    prepareDrawer() {
      const tier = this.selectedTier;
      const confirmed = this.confirmedSelections[tier];

      this.pendingSelections[tier] = confirmed
        ? [...confirmed]
        : this.getDefaultSelections(tier);

      this.renderDrawer();
    }

    selectDrawerColor(button) {
      if (button.disabled) return;

      const piece = button.closest('[data-bundle-piece]');
      const pieceIndex =
        Number(piece?.dataset.bundlePiece) - 1;

      if (pieceIndex < 0 || pieceIndex >= this.selectedTier) {
        return;
      }

      this.pendingSelections[this.selectedTier][pieceIndex] =
        button.dataset.colorValue;

      this.renderDrawer();
    }

    confirmColors() {
      const selections =
        this.pendingSelections[this.selectedTier] || [];

      if (!this.areSelectionsValid(
        selections,
        this.selectedTier
      )) {
        return;
      }

      this.confirmedSelections[this.selectedTier] = [
        ...selections
      ];

      this.clearError();
      this.updateInterface();
      this.drawer?.hide();
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;

      this.currentSize =
        variant?.options?.[
          Number(this.config.sizeOptionIndex)
        ] ||
        this.getSelectedSize() ||
        this.currentSize;

      let selectionInvalidated = false;

      for (let tier = 1; tier <= this.maxTier; tier += 1) {
        const confirmed = this.confirmedSelections[tier];

        if (
          confirmed &&
          !this.areSelectionsAvailable(confirmed)
        ) {
          this.confirmedSelections[tier] = null;
          selectionInvalidated = true;
        }

        this.pendingSelections[tier] =
          this.getDefaultSelections(tier);
      }

      if (selectionInvalidated) {
        this.showError(
          this.config.labels.unavailableError
        );
      }
      else {
        this.clearError();
      }

      this.syncSizeOptionAvailability();
      this.updateInterface();

      if (this.drawer?.open) {
        this.prepareDrawer();
      }
    }

    updateInterface() {
      this.updateCards();
      this.updatePrices();
      this.syncSubmitButtons();

      if (this.drawer?.open) {
        this.renderDrawer();
      }
    }

    updateCards() {
      this.cards.forEach((card) => {
        const tier = Number(card.dataset.bundleTier);
        const selected = tier === this.selectedTier;
        const confirmed = this.confirmedSelections[tier];

        const radio = card.querySelector(
          '[data-bundle-radio]'
        );

        const selectButton = card.querySelector(
          '.product-bundle-offer__select-colors'
        );

        const confirmedContainer = card.querySelector(
          '[data-confirmed-colors]'
        );

        card.classList.toggle('is-selected', selected);
        card.dataset.selected = String(selected);

        if (radio) radio.checked = selected;

        if (selectButton) {
          selectButton.hidden =
            !selected || Boolean(confirmed);
        }

        if (confirmedContainer) {
          confirmedContainer.hidden =
            !selected || !confirmed;
        }

        if (confirmed) {
          this.renderConfirmedSwatches(
            card,
            confirmed
          );
        }
      });
    }

    renderConfirmedSwatches(card, selections) {
      const container = card.querySelector(
        '[data-confirmed-swatches]'
      );

      if (!container) return;

      const fragment = document.createDocumentFragment();

      selections.forEach((color) => {
        const sourceButton = this.colorButtons.find(
          (button) =>
            button.dataset.colorValue === color
        );

        const swatch = document.createElement('span');

        swatch.className =
          'color-swatch product-bundle-offer__swatch relative';

        swatch.title = color;
        swatch.setAttribute('aria-label', color);

        const background =
  sourceButton?.dataset.swatchBackground;

const secondColor =
  sourceButton?.dataset.swatchSecondColor;

const image =
  sourceButton?.dataset.swatchImage;

if (background) {
  swatch.style.setProperty(
    '--swatch-background',
    background
  );
}

if (background && secondColor) {
  swatch.style.backgroundImage =
    `conic-gradient(from 90deg, ${background} 25%, ${secondColor} 0 50%, ${background} 0 75%, ${secondColor} 0)`;
} else if (image) {
  swatch.style.backgroundImage =
    `url("${image}")`;
}

        fragment.appendChild(swatch);
      });

      container.replaceChildren(fragment);
    }

    renderDrawer() {
      const tier = this.selectedTier;
      const selections =
        this.pendingSelections[tier] ||
        this.getDefaultSelections(tier);

      this.pieceElements.forEach((piece) => {
        const pieceNumber =
          Number(piece.dataset.bundlePiece);

        const visible = pieceNumber <= tier;
        const selectedColor =
          selections[pieceNumber - 1];

        piece.hidden = !visible;

        if (!visible) return;

        const selectedText = piece.querySelector(
          '[data-piece-selected-color]'
        );

        if (selectedText) {
          selectedText.textContent =
            selectedColor || '';
        }

        piece
          .querySelectorAll('[data-bundle-color]')
          .forEach((button) => {
            const color = button.dataset.colorValue;
           const requiredQuantity =
  selections
    .slice(0, tier)
    .filter(
      (selectedColorValue, index) =>
        index !== pieceNumber - 1 &&
        selectedColorValue === color
    ).length + 1;

const available =
  this.isColorAvailable(
    color,
    this.currentSize,
    requiredQuantity
  );

const selected =
  color === selectedColor;

            button.disabled = !available;
            button.classList.toggle(
              'is-selected',
              selected
            );

            button.classList.toggle(
              'is-unavailable',
              !available
            );

            button.setAttribute(
              'aria-checked',
              String(selected)
            );

            button.setAttribute(
              'aria-disabled',
              String(!available)
            );
          });
      });

      if (this.confirmButton) {
        this.confirmButton.disabled =
          !this.areSelectionsValid(
            selections,
            tier
          );
      }
    }

    updatePrices() {
  this.cards.forEach((card) => {
    const tier = Number(card.dataset.bundleTier);

    const discount =
      Number(this.config.discounts[tier]) || 0;

    const usesBuy2Get1 =
      tier === 3 &&
      (
        this.config.tier3Buy2Get1 === true ||
        this.config.tier3Buy2Get1 === 'true'
      );

    const selections =
      this.confirmedSelections[tier] ||
      this.pendingSelections[tier] ||
      this.getDefaultSelections(tier);

    const selectedVariants = selections
      .slice(0, tier)
      .map((color) =>
        this.findVariant(
          color,
          this.currentSize
        )
      )
      .filter(Boolean);

    /*
     * Mantém o preço inicial do Liquid quando ainda
     * não existem variantes suficientes para o nível.
     */
    if (selectedVariants.length !== tier) return;

    const prices = selectedVariants.map(
      (variant) => Number(variant.price || 0)
    );

    const originalTotal = prices.reduce(
      (total, price) => total + price,
      0
    );

    let discountedTotal;

    if (usesBuy2Get1) {
      /*
       * Três produtos são selecionados e o produto
       * de menor valor fica gratuito.
       */
      const freeItemPrice = Math.min(...prices);

      discountedTotal =
        originalTotal - freeItemPrice;
    } else {
      discountedTotal = prices.reduce(
        (total, price) =>
          total +
          Math.round(
            price * (100 - discount) / 100
          ),
        0
      );
    }

    const hasOffer =
      usesBuy2Get1 || discount > 0;

    const discountedUnitPrice = Math.round(
      discountedTotal / Math.max(1, tier)
    );

    const priceElement = card.querySelector(
      '[data-bundle-price]'
    );

    const compareElement = card.querySelector(
      '[data-bundle-compare-price]'
    );

    const unitPriceElement = card.querySelector(
      '[data-bundle-unit-price]'
    );

    if (priceElement) {
      priceElement.textContent =
        this.formatMoney(discountedTotal);

      priceElement.classList.toggle(
        'product-bundle-offer__price--sale',
        hasOffer
      );
    }

    if (compareElement) {
      compareElement.textContent =
        this.formatMoney(originalTotal);

      compareElement.hidden = !hasOffer;
    }

    if (unitPriceElement) {
      const perLabel =
        this.config.perLabel || 'per';

      const unitLabel =
        this.config.unitLabel || 'Piece';

      unitPriceElement.textContent =
        `${this.formatMoney(discountedUnitPrice)} ${perLabel} ${unitLabel}`;
    }
  });
}

    syncSizeOptionAvailability() {
      const optionNumber =
        Number(this.config.sizeOptionIndex) + 1;

      const sizeGroup = this.section?.querySelector(
        `[data-option-index="option${optionNumber}"]`
      );

      if (!sizeGroup) return;

      sizeGroup
        .querySelectorAll('input[data-option-value]')
        .forEach((input) => {
          const available =
            this.isSizeAvailable(input.value);

          input.disabled = !available;
          input.classList.toggle(
            'disabled',
            !available
          );
        });

      sizeGroup
        .querySelectorAll('option')
        .forEach((option) => {
          option.disabled =
            !this.isSizeAvailable(option.value);
        });
    }

    syncSubmitButtons() {
      if (this.loading) return;

      const anyAvailable =
        this.getAvailableColorsForSize(
          this.currentSize
        ).length > 0;

      this.getSubmitButtons().forEach((button) => {
        button.disabled = !anyAvailable;

        if (anyAvailable) {
          button.removeAttribute('aria-disabled');

          const text =
            button.querySelector('.btn-text span') ||
            button.querySelector('.btn-text');

          if (text && window.theme?.variantStrings) {
            text.textContent =
              theme.variantStrings.addToCart;
          }
        }
      });
    }

    async handleFormSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (this.loading) return;

      const confirmed =
        this.confirmedSelections[this.selectedTier];

      if (
  !confirmed ||
  confirmed.length !== this.selectedTier
) {
  this.showError(
    this.config.labels.selectColorsError
  );

  return;
}

    if (!this.areSelectionsAvailable(confirmed)) {
  this.confirmedSelections[this.selectedTier] =
    null;

  this.showError(
    this.config.labels.unavailableError
  );

  this.updateInterface();
  return;
}

      const variants = confirmed.map((color) =>
        this.findVariant(color, this.currentSize)
      );

      const bundleIdentifier =
        this.createBundleIdentifier();

      const itemsByVariant = new Map();

      variants.forEach((variant) => {
        const existing =
          itemsByVariant.get(String(variant.id));

        if (existing) {
          existing.quantity += 1;
          return;
        }

        itemsByVariant.set(String(variant.id), {
          id: variant.id,
          quantity: 1,
          properties: {
            _bundle_id: bundleIdentifier,
            _bundle_tier:
              `${this.selectedTier} pieces`,
            _bundle_size: this.currentSize
          }
        });
      });

      await this.addItemsToCart(
        Array.from(itemsByVariant.values()),
        event.submitter || null
      );
    }

    async addItemsToCart(items, submitter) {
      this.setLoading(true);
      this.clearError();

      try {
        const sections = [];

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections }
          })
        );

        const response = await fetch(
          theme.routes.cart_add_url,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname
            })
          }
        );

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
            result.message ||
            this.config.labels.addError
          );
        }

        if (
          document.body.classList.contains(
            'template-cart'
          ) ||
          theme.settings.cartType === 'page'
        ) {
          window.location.href =
            theme.routes.cart_url;
          return;
        }

        const cartResponse = await fetch(
          theme.routes.cart_url,
          theme.utils.fetchConfig()
        );

        const cart = await cartResponse.json();
        cart.sections = result.sections;

        theme.pubsub.publish(
          theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          { cart }
        );

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: result
            }
          })
        );

        document
          .querySelector('cart-drawer')
          ?.show(submitter);
      }
      catch (error) {
        this.showError(
          error.message ||
          this.config.labels.addError
        );
      }
      finally {
        this.setLoading(false);
        this.syncSubmitButtons();
      }
    }

    setLoading(loading) {
      this.loading = loading;

      this.getSubmitButtons().forEach((button) => {
        if (loading) {
          button.setAttribute(
            'aria-disabled',
            'true'
          );

          button.setAttribute(
            'aria-busy',
            'true'
          );
        }
        else {
          button.removeAttribute('aria-busy');
          button.removeAttribute('aria-disabled');
        }
      });
    }

    getSubmitButtons() {
      return Array.from(
        document.querySelectorAll(
          `[type="submit"][form="${this.config.productFormId}"], #${this.config.productFormId} [type="submit"]`
        )
      );
    }

    getColorValues() {
      const firstPiece = this.drawer?.querySelector(
        '[data-bundle-piece="1"]'
      );

      if (!firstPiece) return [];

      return Array.from(
        firstPiece.querySelectorAll(
          '[data-bundle-color]'
        )
      ).map((button) => button.dataset.colorValue);
    }

    getSelectedSize() {
      const optionNumber =
        Number(this.config.sizeOptionIndex) + 1;

      const sizeGroup = this.section?.querySelector(
        `[data-option-index="option${optionNumber}"]`
      );

      if (!sizeGroup) return '';

      const checkedInput =
        sizeGroup.querySelector('input:checked');

      const select =
        sizeGroup.querySelector('select');

      return checkedInput?.value ||
        select?.value ||
        '';
    }

    getFirstAvailableSize() {
      const sizeIndex =
        Number(this.config.sizeOptionIndex);

      const variant = this.variants.find(
        (item) => item.available
      ) || this.variants[0];

      return this.getVariantOptions(variant)[sizeIndex] || '';
    }

    getAvailableColorsForSize(size) {
  return this.colors.filter((color) =>
    this.isColorAvailable(color, size)
  );
}

getDefaultSelections(tier) {
  const selections = [];

  while (selections.length < tier) {
    let colorAdded = false;

    for (const color of this.colors) {
      const requiredQuantity =
        selections.filter(
          (selectedColor) => selectedColor === color
        ).length + 1;

      if (
        this.isColorAvailable(
          color,
          this.currentSize,
          requiredQuantity
        )
      ) {
        selections.push(color);
        colorAdded = true;
      }

      if (selections.length === tier) break;
    }

    if (!colorAdded) break;
  }

  return selections;
}

getVariantAvailableQuantity(variant) {
  if (!variant || variant.available === false) {
    return 0;
  }

  if (
    !variant.inventory_management ||
    variant.inventory_policy === 'continue'
  ) {
    return Number.POSITIVE_INFINITY;
  }

  const quantity = Number.parseInt(
    variant.inventory_quantity,
    10
  );

  if (!Number.isFinite(quantity)) {
    return variant.available ? 1 : 0;
  }

  return Math.max(0, quantity);
}

isColorAvailable(
  color,
  size,
  requiredQuantity = 1
) {
  const variant = this.findVariant(color, size);

  return (
    this.getVariantAvailableQuantity(variant) >=
    requiredQuantity
  );
}

    isSizeAvailable(size) {
      const colorIndex =
        Number(this.config.colorOptionIndex);

      const sizeIndex =
        Number(this.config.sizeOptionIndex);

      return this.variants.some((variant) => {
        const options =
          this.getVariantOptions(variant);

        return (
          options[colorIndex] &&
          options[sizeIndex] === size &&
          variant.available
        );
      });
    }

    findVariant(color, size) {
      const colorIndex =
        Number(this.config.colorOptionIndex);

      const sizeIndex =
        Number(this.config.sizeOptionIndex);

      return this.variants.find((variant) => {
        const options =
          this.getVariantOptions(variant);

        return (
          options[colorIndex] === color &&
          options[sizeIndex] === size
        );
      });
    }

    getVariantOptions(variant) {
      if (!variant) return [];

      if (Array.isArray(variant.options)) {
        return variant.options;
      }

      return [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter((value) => value != null);
    }

   areSelectionsAvailable(selections) {
  const requestedQuantities = new Map();

  return selections.every((color) => {
    const requiredQuantity =
      (requestedQuantities.get(color) || 0) + 1;

    requestedQuantities.set(
      color,
      requiredQuantity
    );

    return this.isColorAvailable(
      color,
      this.currentSize,
      requiredQuantity
    );
  });
}

    areSelectionsValid(selections, tier) {
      return (
        selections.length === tier &&
        selections.every(Boolean) &&
        this.areSelectionsAvailable(selections)
      );
    }

    parseTier(value, fallback) {
      const parsed = Number.parseInt(value, 10);

      if (!Number.isFinite(parsed)) return fallback;

     return Math.min(
  this.maxTier || 3,
  Math.max(1, parsed)
);
    }

    parseJson(selector, fallback = null) {
      const element = this.querySelector(selector);

      if (!element) return fallback;

      try {
        return JSON.parse(element.textContent);
      }
      catch (error) {
        console.warn(
          'Bundle configuration could not be parsed.',
          error
        );

        return fallback;
      }
    }

    formatMoney(cents) {
      const currency =
        this.config.currencyCode || 'EUR';

      const locale =
        document.documentElement.lang ||
        navigator.language ||
        'en';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(Number(cents) / 100);
      }
      catch (error) {
        return `${(Number(cents) / 100).toFixed(2)} ${currency}`;
      }
    }

    createBundleIdentifier() {
      if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
      }

      return [
        Date.now(),
        Math.random()
          .toString(16)
          .slice(2)
      ].join('-');
    }

  showError(message) {
  const errorElement = this.querySelector(
    '[data-bundle-error]'
  );

  if (!errorElement) return;

  clearTimeout(this.errorTimeout);
  clearTimeout(this.errorAnimationTimeout);

  errorElement.classList.remove('is-hiding');
  errorElement.textContent = message;
  errorElement.hidden = false;

  this.errorTimeout = setTimeout(() => {
    errorElement.classList.add('is-hiding');

    this.errorAnimationTimeout = setTimeout(() => {
      errorElement.textContent = '';
      errorElement.hidden = true;
      errorElement.classList.remove('is-hiding');
    }, 450);
  }, 5000);
}

    clearError() {

      clearTimeout(this.errorTimeout);
clearTimeout(this.errorAnimationTimeout);
this.errorTimeout = null;
this.errorAnimationTimeout = null;

      const errorElement = this.querySelector(
        '[data-bundle-error]'
      );

      if (errorElement) {
        errorElement.classList.remove('is-hiding');
        errorElement.textContent = '';
        errorElement.hidden = true;
      }

      const formError = this.form?.querySelector(
        '.product-form__error-message'
      );

      if (formError) {
        formError.textContent = '';
        formError.hidden = true;
      }
    }
  }

  customElements.define(
    'product-bundle-offer',
    ProductBundleOffer
  );
})();